// extracted by mini-css-extract-plugin
export default {"lastValuesContainer":"MomiLastValuesMetrics_lastValuesContainer__-fvKP","metricsGrid":"MomiLastValuesMetrics_metricsGrid__N8ovr"};